import {connect} from 'react-redux';
import {bindActionCreators} from 'redux';
import {
  userIsAdminForStag,
  selectedStagSelector,
  peopleWithPointsSelector,
  addPointsChange,
} from '../../../reducers';

import Person from './component';

const mapStateToProps = (state) => {
  return {
    adminVisible: userIsAdminForStag(state, selectedStagSelector(state)) ? true : false,
    peopleWithPoints: peopleWithPointsSelector(state) || {},
  }
};

const mapDispatchToProps = (dispatch) => {
  return bindActionCreators({
    addPointsChange,
  }, dispatch);
};

export default connect(mapStateToProps, mapDispatchToProps)(Person);



// WEBPACK FOOTER //
// ./src/component/organisms/Person/index.js